var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IndexationTableWidget',{attrs:{"is-read-only-mode":_vm.isReadOnlyMode,"currentIndexations":_vm.indexations}})
}
var staticRenderFns = []

export { render, staticRenderFns }